import get from "lodash/get";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { Button } from "../../../atoms";
import { GridView } from "../../mpw-detail-page/grid-view";
import "./winner-section.m.css";

const WinnerCard = ({ name, role, imageUrl }) => (
  <div styleName="winner">
    <img src={imageUrl} alt={name} styleName="winner-image" />
    <div styleName="winner-info">
      <h3 styleName="winner-name">{name}</h3>
      <p styleName="winner-role">{role}</p>
    </div>
  </div>
);

WinnerCard.propTypes = {
  name: PropTypes.string.isRequired,
  role: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
};

export const WinnersSection = ({ card, cdnImage }) => {
  if (!card) return null;
  const [visibleItems, setVisibleItems] = useState(8);
  const { title = "", description = "", sortByRank = [] } = card;
  const sortByRankFinal = sortByRank?.filter((item) => item["entity-type"] !== "year");
  const loadMore = () => {
    setVisibleItems((prev) => prev + 8);
  };
  const id = get(card, ["metadata", "attributes", "menuname", "0"], "");

  return (
    <div styleName="winners-section-container" id={`${id.toLowerCase()}`}>
      {title && (
        <>
          <h2 styleName="title" dangerouslySetInnerHTML={{ __html: title }} />
          <hr styleName="divider" />
        </>
      )}
      {description && <div styleName="description" dangerouslySetInnerHTML={{ __html: description }} />}
      <div styleName="grid-container">
        <GridView
          snapshotByRank={sortByRankFinal}
          visibleItemsForGrid={visibleItems}
          rankingEntitySlug={
            sortByRankFinal?.[0]?.["entity-type"] === "forty-under-forty-snapshot" ? "" : "most-powerful-women"
          }
          cdnImage={cdnImage}
          isSsr={true}
        />
      </div>
      {visibleItems < sortByRankFinal.length && (
        <div styleName="load-more-button" onClick={loadMore}>
          <Button>View More</Button>
        </div>
      )}
    </div>
  );
};

WinnersSection.propTypes = {
  sortByRank: PropTypes.array,
  cdnImage: PropTypes.string.isRequired,
};
